/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KakaoAddressResponse } from '../../models/kakao-address-response';

export interface KakaoAuthControllerSearchAddress$Params {

/**
 * 검색할 주소
 */
  address?: string;
}

export function kakaoAuthControllerSearchAddress(http: HttpClient, rootUrl: string, params?: KakaoAuthControllerSearchAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<KakaoAddressResponse>> {
  const rb = new RequestBuilder(rootUrl, kakaoAuthControllerSearchAddress.PATH, 'get');
  if (params) {
    rb.query('address', params.address, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KakaoAddressResponse>;
    })
  );
}

kakaoAuthControllerSearchAddress.PATH = '/api/oauth/kakao/search';
